import { useState, type FormEvent } from 'react';
import { useNavigate } from 'react-router-dom';

interface SearchBarProps {
  defaultValue?: string;
  placeholder?: string;
  size?: 'sm' | 'lg';
  className?: string;
  autoNavigate?: boolean;
  onSubmitKeyword?: (keyword: string) => void;
}

export default function SearchBar({
  defaultValue = '',
  placeholder = '搜索漫画名、作者或关键词',
  size = 'sm',
  className = '',
  autoNavigate = true,
  onSubmitKeyword,
}: SearchBarProps) {
  const [keyword, setKeyword] = useState(defaultValue);
  const navigate = useNavigate();

  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const trimmed = keyword.trim();
    if (onSubmitKeyword) {
      onSubmitKeyword(trimmed);
      return;
    }
    if (!autoNavigate) return;
    navigate(trimmed ? `/search?q=${encodeURIComponent(trimmed)}` : '/search');
  };

  const isLarge = size === 'lg';

  return (
    <form
      onSubmit={handleSubmit}
      role="search"
      className={`flex w-full items-center gap-2 rounded-full border border-background-200 bg-background-50 pl-4 pr-2 shadow-sm transition-colors focus-within:border-primary-400 ${
        isLarge ? 'h-14' : 'h-10'
      } ${className}`}
    >
      <i className={`ri-search-line text-foreground-400 ${isLarge ? 'text-lg' : 'text-sm'}`}></i>
      <input
        type="search"
        name="keyword"
        value={keyword}
        onChange={(event) => setKeyword(event.target.value)}
        placeholder={placeholder}
        className={`h-full min-w-0 flex-1 bg-transparent text-foreground-900 outline-none placeholder:text-foreground-400 ${
          isLarge ? 'text-base' : 'text-sm'
        }`}
      />
      <button
        type="submit"
        className={`flex items-center justify-center gap-1 whitespace-nowrap rounded-full bg-primary-500 font-medium text-background-50 transition-colors hover:bg-primary-600 cursor-pointer ${
          isLarge ? 'h-10 px-6 text-sm' : 'h-8 px-4 text-xs'
        }`}
      >
        <i className="ri-search-line"></i>
        搜索
      </button>
    </form>
  );
}